<template>
  <PublicLayout>
    <h1 class="public__title">Conditions générales</h1>
    <p class="public__lead">
      Ce document présente les règles d’utilisation du service Saineo. Les informations ci-dessous sont à compléter.
    </p>

    <h2 class="public__section-title">Principes</h2>
    <ul class="public__list">
      <li>Utilisation responsable des contenus et recommandations</li>
      <li>Respect des droits d’auteur et des mentions légales</li>
      <li>Protection des données personnelles</li>
    </ul>

    <h2 class="public__section-title">Éligibilité</h2>
    <p class="public__text">
      Le service est destiné aux personnes majeures ou aux mineurs accompagnés d’un responsable légal.
    </p>
  </PublicLayout>
</template>

<script>
import PublicLayout from './PublicLayout.vue';

export default {
  name: 'TermsPage',
  components: { PublicLayout },
};
</script>
